import React from "react";
import CurrencyInput from "react-currency-input";
import { Dropdown, Table, FormCheck } from "react-bootstrap";
import styled from "styled-components";

import { decimalFormat, formatCurrencyValue } from "../../../../../utils";
import IModal from "../../../../../_components/Modal";

import ScrollBox from "../../../../../_components/ScrollBox";
import Text from "../../../../../_components/Text";
import Button from "../../../../../_components/Button";
import { CreateNFeContext } from "../Context";
import AppContext from "../../../../AppViews/context";
import { cst as ICMSCST } from "../../../Taxes/ICMS/Template";
import { CSOSN_DATA } from "../../../Taxes/ICMS/data";
import { CSTData as CSTIPI } from "../../../Taxes/IPI/Template";
import { cstData as CSTPIS } from "../../../Taxes/PIS/Template";
import { cofinsCstdata as CSTCOFINS } from "../../../Taxes/COFINS/Template/index";

import { getBranchOwner } from "@config"

import ChangesItem from "./ChangesItem";

let branch = getBranchOwner()
const defaultItemData = { cfop_suggested: [], icms: {} };

const IconEdit = styled.i`
  cursor: pointer;
  font-size: 10px;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: -20px;
  padding: 0px;
`;

export default function NFeItems(props) {
  const context = React.useContext(CreateNFeContext);

  const [loading, setLoading] = React.useState(false);
  const [currentItem, setCurrentItem] = React.useState({
    cfop_suggested: [],
    icms: {},
  });
  const [modalTax, setModalTax] = React.useState({
    icms: false,
    ipi: false,
    pis: false,
    cofins: false,
  });
  const [showModalCFOP, setShowModalCFOP] = React.useState(false);
  const [cfopSearchResult, setCFOPSearchResult] = React.useState([]);
  const [inputCFOPSearch, setInputCFOPSearch] = React.useState("");
  const [modalEditQuantity, showModalEditQuantity] = React.useState(false);
  const [itemQuantity, setItemQuantity] = React.useState(0);
  const [modalEditPrice, showModalEditPrice] = React.useState(false);
  const [itemPrice, setItemPrice] = React.useState(0);

  function onShowModalEditCFOP(item) {
    setCurrentItem(item);
    setShowModalCFOP(true);
  }
  function onShowModalEditQuantity(item) {
    setCurrentItem(item);
    showModalEditQuantity(true);
    setItemQuantity(item.quantity);
    setTimeout(() => {
      try {
        document.getElementById("nfe-issuer-input-edit-quantity").focus();
      } catch (error) { }
    }, 400);
  }
  function closeModalEditQuantity() {
    showModalEditQuantity(false);
    setCurrentItem(defaultItemData);
    setItemQuantity(0);
  }
  function onShowModalEditPrice(item) {
    showModalEditPrice(item);
    setCurrentItem(item);
    setItemPrice(item.item_sale_price);
  }
  function onCloseModalEditPrice() {
    showModalEditPrice(false);
    setItemPrice(0);
    setCurrentItem(defaultItemData);
  }
  function openModalTaxTemplate(item, tax) {
    setCurrentItem({
      ...item,
      tax,
    });
    setModalTax({ [tax]: true });
  }
  function closeModalTaxTemplate() {
    setCurrentItem(defaultItemData);
    setModalTax({ [currentItem.tax]: false });
  }
  function updateItemTaxTemplate(data) {
    const { updateNFeItem } = context["handlers"];
    updateNFeItem(
      { ...currentItem, [`${currentItem.tax}`]: data },
      currentItem.index
    );
    setTimeout(() => {
      setCurrentItem(defaultItemData);
      closeModalTaxTemplate();
    }, 100);
  }
  function openModalEditItem(item, key) {
    item.showEditItemField = true;
    item.fieldKey = key;
    setCurrentItem(item);
  }

  return (
    <ScrollBox>
      <DesktopItemsTable
        currentItem={currentItem.id}
        items={context.nfe.items}
        onShowModalEditCFOP={onShowModalEditCFOP}
        onEditItem={openModalEditItem}
        openModalTaxTemplate={openModalTaxTemplate}
        onShowModalEditQuantity={onShowModalEditQuantity}
        onShowModalEditPrice={onShowModalEditPrice}
        removeNFeItem={context.handlers.removeNFeItem}
      />
      <AdjstICMS
        data={currentItem}
        show={modalTax.icms}
        onHide={closeModalTaxTemplate}
        onSave={updateItemTaxTemplate}
      />
      <AdjstIPI
        data={currentItem}
        show={modalTax.ipi}
        onHide={closeModalTaxTemplate}
        onSave={updateItemTaxTemplate}
      />
      <AdjustPIS
        data={currentItem}
        show={modalTax.pis}
        onHide={closeModalTaxTemplate}
        onSave={updateItemTaxTemplate}
      />
      <AdjustCOFINS
        data={currentItem}
        show={modalTax.cofins}
        onHide={closeModalTaxTemplate}
        onSave={updateItemTaxTemplate}
      />
    </ScrollBox>
  );
}
function DesktopItemsTable(props) {
  const [showIndex, setShowIndex] = React.useState();
  function showHide(index) {
    if (showIndex === index) {
      setShowIndex(null);
    } else {
      setShowIndex(index);
    }
  }

  function onClickOption(item, title = "", key = "") {
    //console.debug("onClickOption");
    item.title = title;
    setShowIndex(undefined);
    props.onEditItem(item, key);
  }

  return (
    <div className="mt-2 mb-5">
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>
              <Text>Item</Text>
            </th>
            <th>
              <Text>Cód.</Text>
            </th>
            <th>
              <Text>Descrição</Text>
            </th>
            <th>
              <Text>CFOP</Text>
            </th>
            <th>
              <Text>ICMS (CST/CSOSN)</Text>
            </th>
            <th>
              <Text>IPI</Text>
            </th>
            <th>
              <Text>Qtd.</Text>
            </th>
            <th>
              <Text>Valor</Text>
            </th>
            <th>
              <Text>Total</Text>
            </th>
            <th>
              <Text>Ações</Text>
            </th>
          </tr>
        </thead>
        <tbody style={{ maxHeight: "100vh" }}>
          {props.items.map((item, index) => {
            item.index = index;
            item.cfop_suggested = item.cfop_suggested || [];
            const _sellable = item.sellable || {};
            const _unitBranch = _sellable.unit_branch || {};
            item.unit_name = _unitBranch.name || item.unit || item.unit_name || "UN";
            const code = _sellable.code || null;
            const name = _sellable.name || item.description || "";
            const total = formatCurrencyValue(
              +((item.quantity * item.item_sale_price)
                + Number((item.ipi && item.ipi.v_ipi) || 0)
                // ICMS-ST entra no total do item (compõe vNF). ICMS próprio, PIS e COFINS NÃO.
                + Number((item.icms && item.icms.v_icms_st) || 0)
              ).toFixed(3)
            );
            const sale_price = formatCurrencyValue(parseFloat(item.item_sale_price) || 0);

            const unit_name = _unitBranch.name || item.unit || item.unit_name || "UN";
            let cstCsosn = ""
            const isCSTList = branch.crt == 3 || branch.crt == 2;
            if (isCSTList) {
              cstCsosn = item.icms.cst
            } else {
              cstCsosn = item.icms.csosn
            }
            return (
              <tr key={`nfe-items-list-item-${item.id}-${index}`}>
                <td>
                  <Text>{index + 1}</Text>
                </td>
                <td>
                  <Text>{code}</Text>
                </td>
                <td>
                  <div className="d-flex">
                    <Text>{name}</Text>
                    <ChangesItem index={index} setFocus="description" item={item} />
                  </div>
                </td>
                <td
                  title={item.invalid_cfop ? item.invalid_cfop_message : ""}
                  className={`${item.invalid_cfop ? "bg-warning text-white" : ""
                    }`}
                >
                  <div className="d-flex">
                    <Text>
                      {item.cfop_code}
                      {item.invalid_cfop ? <small>CFOP Inválido</small> : ""}
                    </Text>
                    <ChangesItem setFocus="cfop" item={item} />
                  </div>
                </td>
                <td>
                  <Text>
                    {cstCsosn}
                    &nbsp;
                    <IconEdit
                      onClick={() => props.openModalTaxTemplate(item, "icms")}
                      className="fas fa-pen"
                    />
                    {formatCurrencyValue(item.icms.v_icms || 0)}
                  </Text>
                </td>
                <td>
                  <Text>
                    {formatCurrencyValue((item.ipi && item.ipi.v_ipi) || 0)}
                    <IconEdit
                      onClick={() => props.openModalTaxTemplate(item, "ipi")}
                      className="fas fa-pen"
                    />
                  </Text>
                </td>
                <td>
                  <div className="d-flex">
                    <Text>
                      {item.quantity} {unit_name}
                    </Text>
                    <ChangesItem setFocus="quantity" item={item} />
                  </div>
                </td>
                <td>
                  <div className="d-flex">
                    <Text>
                      {sale_price}
                    </Text>
                    <ChangesItem setFocus="price" item={item} />
                  </div>
                </td>
                <td>
                  <Text>{total}</Text>
                </td>
                <td className="d-flex">
                  <i
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (!item.id) {
                        item.id = item.product;
                      }
                      props.removeNFeItem(item);
                    }}
                    className="fas fa-trash-alt icon-edit text-danger p-1"
                  />
                  <Dropdown drop="left" alignRight={true}>
                    <Dropdown.Toggle
                      style={{ backgroundColor: "transparent", border: "none" }}
                    >
                      <i
                        style={{ cursor: "pointer" }}
                        className="fas fa-ellipsis-v text-black-50"
                      />
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      style={{ zIndex: 1000, position: "absolute" }}
                    >
                      <Dropdown.Item
                        onClick={() => props.openModalTaxTemplate(item, "pis")}
                      >
                        PIS
                      </Dropdown.Item>
                      <Dropdown.Divider></Dropdown.Divider>
                      <Dropdown.Item
                        onClick={() =>
                          props.openModalTaxTemplate(item, "cofins")
                        }
                      >
                        COFINS
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}

function AdjstICMS(props) {
  const context = React.useContext(AppContext);
  const [data, setData] = React.useState({ cs: [] });

  function handleChangeCST(value) {
    const isCST = context.currentBranch.crt == 3 || context.currentBranch.crt == 2;
    let values = {
      name: props.data.icms.name,
      orig: props.data.icms.orig || 0,
      [isCST ? "cst" : "csosn"]: value,
      sample_icms: props.data.icms.sample_icms ? true : false,
      ...(context.currentBranch.crt === 3 && {
        p_icms_inter: props.data.icms.p_icms_inter || 0,
      }),
    };
    const preencheCamposICMS = (keys) => {
      for (let key of keys) {
        values[key] = props.data.icms[key] || 0;
      }
    };
    if (isCST) {
      const cst = value;
      switch (cst) {
        case "00":
          preencheCamposICMS(["mod_bc", "bc_icms", "p_icms", "v_icms"]);
          break;
        case "10":
          preencheCamposICMS([
            "mod_bc_st",
            "p_mva_st",
            "p_red_bc_st",
            "v_bc_st",
            "p_icms_st",
            "v_icms_st",
            "v_fcp",
            "v_fcp_st",
            "bc_fcp",
            "p_fcp"
          ]);
          break;
        case "20":
          preencheCamposICMS([
            "mod_bc",
            "p_red_bc",
            "p_icms",
            "v_icms",
            "v_fcp",
            "bc_fcp",
            "p_fcp",
            "bc_icms",
            "v_icms_deson",
            "mot_des_icms",
          ]);
          break;
        case "30":
          preencheCamposICMS([
            "mod_bc_st",
            "p_mva_st",
            "p_red_bc_st",
            "v_bc_st",
            "p_icms",
            "v_icms_st",
            "v_fcp_st",
            "bc_fcp",
            "p_fcp",
            "v_icms_deson",
            "mot_des_icms",
          ]);
          break;
        case "40":
        case "41":
        case "50":
          preencheCamposICMS(["v_icms", "v_icms_deson", "mot_des_icms"]);
          break;
        case "51":
          preencheCamposICMS([
            "v_fcp",
            "bc_fcp",
            "p_fcp"
          ]);
          break;
        case "60":
          preencheCamposICMS([
            "v_bc_st_ret",
            "v_icms_st_ret",
            "v_fcp_st_ret",
            "bc_fcp",
            "p_fcp"
          ]);
          break;
        case "70":
          preencheCamposICMS([
            "p_red_bc",
            "bc_icms",
            "p_icms",
            "v_icms",
            "mod_bc_st",
            "p_mva_st",
            "p_red_bc_st",
            "v_bc_st",
            "p_icms_st",
            "v_icms_st",
            "bc_fcp",
            "p_fcp",
            "v_fcp_st",
            "v_icms_deson",
            "mot_des_icms",
          ]);
          break;
        case "90":
          preencheCamposICMS([
            "p_red_bc",
            "bc_icms",
            "p_icms",
            "v_icms",
            "mod_bc_st",
            "p_mva_st",
            "p_red_bc_st",
            "v_bc_st",
            "p_icms_st",
            "v_icms_st",
            "v_fcp",
            "v_fcp_st",
            "bc_fcp",
            "p_fcp",
            "v_icms_deson",
            "mot_des_icms",
          ]);
          break;
      }
    } else {
      const csosn = value;
      switch (csosn) {
        case "101":
          preencheCamposICMS(["p_cred_sn", "v_cred_icms_sn"]);
          break;
        case "102":
        case "103":
        case "300":
        case "400":
          break;
        case "201":
          preencheCamposICMS([
            "mod_bc_st",
            "p_mva_st",
            "p_red_bc_st",
            "v_bc_st",
            "p_icms_st",
            "v_icms_st",
            "p_cred_sn",
            "v_cred_icms_sn",
          ]);
          break;
        case "202":
          preencheCamposICMS([
            "mod_bc_st",
            "p_mva_st",
            "p_red_bc_st",
            "v_bc_st",
            "p_icms_st",
            "v_icms_st",
            "v_fcp",
            "bc_fcp",
            "p_fcp"
          ]);
          break
        case "203":
          preencheCamposICMS([
            "mod_bc_st",
            "p_mva_st",
            "p_red_bc_st",
            "v_bc_st",
            "p_icms_st",
            "v_icms_st",
          ]);
          break;
        case "500":
          preencheCamposICMS([
            "v_bc_st_ret",
            "v_icms_st_ret",
            "v_fcp_st_ret",
            "bc_fcp",
            "p_fcp",

          ]);
          break;
        case "900":
          preencheCamposICMS([
            "mod_bc",
            "bc_icms",
            "p_red_bc",
            "p_icms",
            "v_icms",
            "mod_bc_st",
            "p_mva_st",
            "p_red_bc_st",
            "v_bc_st",
            "p_icms_st",
            "v_icms_st",
            "p_cred_sn",
            "v_cred_icms_sn",
            "v_fcp",
            "bc_fcp",
            "p_fcp",
            "v_icms_deson",
            "mot_des_icms",
          ]);
          break;
      }
    }
    setData(values);
  }
  function onChange(e) {
    const { name: key, value } = e.target;
    setData({
      ...data,
      [key]: value,
    });
    setTimeout(() => {
      if (["p_icms", "bc_icms"].includes(key)) {
        let percent = 0;
        let baseValue = 0;

        if (key === "p_icms") {
          percent = value;
          baseValue = data.bc_icms || 0;
        } else if (key === "bc_icms") {
          baseValue = value;
          percent = data.p_icms || 0;
        }
        const v_icms = decimalFormat((percent / 100) * baseValue, 4);
        setData({
          ...data,
          [key]: value,
          v_icms,
        });
      }

      if (["p_fcp", "bc_fcp"].includes(key)) {
        let percent = 0;
        let baseValue = 0;


        if (key === "p_fcp") {

          percent = value;
          baseValue = data.bc_fcp || 0;
        } else if (key === "bc_fcp") {
          baseValue = value;
          percent = data.p_icms || 0;
        }
        const v_fcp = decimalFormat((percent / 100) * baseValue, 4);
        setData({
          ...data,
          [key]: value,
          v_fcp,
        });
      }

      if (["p_icms_st", "v_bc_st", "p_mva_st"].includes(key)) {
        let p_st = key === "p_icms_st" ? parseFloat(value) || 0 : parseFloat(data.p_icms_st) || 0;
        let v_bc_st = key === "v_bc_st" ? parseFloat(value) || 0 : parseFloat(data.v_bc_st) || 0;
        let p_mva_st = key === "p_mva_st" ? parseFloat(value) || 0 : parseFloat(data.p_mva_st) || 0;
        let bc_icms = parseFloat(data.bc_icms) || 0;

        if (key === "p_mva_st" && p_mva_st > 0 && bc_icms > 0) {
          v_bc_st = decimalFormat(bc_icms * (1 + p_mva_st / 100), 4);
        }

        let v_icms_st = data.v_icms_st;
        if (p_st > 0 && v_bc_st > 0) {
          const v_icms_proprio = parseFloat(data.v_icms) || 0;
          v_icms_st = decimalFormat(Math.max(0, (v_bc_st * (p_st / 100)) - v_icms_proprio), 4);
        }

        setData((prev) => ({
          ...prev,
          [key]: value,
          v_bc_st,
          v_icms_st,
        }));
      }

    }, 150);
    switch (key) {
      case "csosn":
      case "cst":
        handleChangeCST(value);
        break;
    }
  }
  function save() {
    props.onHide();
    props.onSave(data);
  }
  function show() {
    if (props.show === true) {
      setTimeout(() => {
        setData({ ...props.data.icms });
        setTimeout(
          () => handleChangeCST(props.data.icms.csosn || props.data.icms.cst),
          250
        );
      }, 250);
    } else {
      setData({ cs: [] });
    }
  }
  React.useEffect(show, [props.show]);
  return (
    <IModal show={props.show} title="ICMS" onHide={props.onHide}>
      <div className="container">
        <div className="row">
          <div className="col-6 col-xs-12">
            <div className="form-group">
              <div className="form-label">
                <Text>Origem</Text>
              </div>
              <select className="form-control" name="orig" onChange={onChange}>
                <option value="" selected disabled>
                  Selecione
                </option>
                <option selected={data.orig == "0"} value="0">
                  0= Nacional
                </option>
                <option selected={data.orig == "1"} value="1">
                  1= Estrangeira
                </option>
                <option selected={data.orig == '2'} value="2">
                  2= Estrangeira - Adquirida no mercado interno, exceto a indicada no código 7
                </option>
                <option selected={data.orig == '3'} value="3">
                  3= Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40% (quarenta por cento) e inferior ou igual a 70% (setenta por cento)
                </option>
                <option selected={data.orig == '4'} value="4">
                  4= Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos (PPB) de que tratam o Decreto-Lei nº 288/1967, e as Leis nºs 8.248/1991, 8.387/1991, 10.176/2001 e 11.484/2007.
                </option>
                <option selected={data.orig == '5'} value="5">
                  5= Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40% (quarenta por cento)
                </option>
                <option selected={data.orig == '6'} value="6">
                  6= Estrangeira, importação direta, sem similar nacional, constante em lista de resolução do conselho de ministros
                </option>
                <option selected={data.orig == '7'} value="7">
                  7= Estrangeira, adquirida no mercado interno, sem similar nacional, constante em lista de resolução da CAMEX
                </option>
                <option selected={data.orig == '8'} value="8">
                  8= Nacional, mercadoria ou bem com Conteúdo de Importação superior a 70%
                </option>
              </select>
            </div>
          </div>
          <div className="col-6 col-xs-12">
            <div className="form-group">
              <div className="form-label">
                <Text>{(context.currentBranch.crt == 3 || context.currentBranch.crt == 2) ? "CST" : "CSOSN"}</Text>
              </div>
              <select
                name={(context.currentBranch.crt == 3 || context.currentBranch.crt == 2) ? "cst" : "csosn"}
                onChange={onChange}
                className="form-control"
              >
                <option value="" selected disabled>
                  Selecione
                </option>
                {(context.currentBranch.crt == 3 || context.currentBranch.crt == 2)
                  ? ICMSCST.map((cst, idx) => {
                    return (
                      <option
                        selected={cst.value === data.cst}
                        value={cst.value}
                      >
                        {cst.value} - {cst.label}
                      </option>
                    );
                  })
                  : CSOSN_DATA.map((csosn, idx) => {
                    return (
                      <option
                        selected={csosn.value === data.csosn}
                        value={csosn.value}
                      >
                        {csosn.label}
                      </option>
                    );
                  })}
              </select>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 my-2">
            <FormCheck
              type="switch"
              id="nfe-adjut-icms-type"
              name="sample_icms"
              onChange={(e) =>
                onChange({
                  target: { name: "sample_icms", value: !data.sample_icms },
                })
              }
              checked={data.sample_icms}
              label={`ICMS ${data.sample_icms ? "Estendido" : "Simplificado"}`}
            />
          </div>
        </div>
        <div className="row">
          <div className={`${data.p_icms != null ? "col-md-4" : "d-none"}`}>
            <div className="form-group">
              <div className="form-label">
                <Text>Alíquota do ICMS</Text>
              </div>
              <CurrencyInput
                value={data.p_icms}
                suffix=" %"
                onChange={(a, value, c) =>
                  onChange({ target: { name: "p_icms", value } })
                }
                className="form-control"
              />
            </div>
          </div>
          <div className={`${data.mod_bc != null ? "col-md-4" : "d-none"}`}>
            <div className="form-group">
              <div className="form-label">
                <Text>Modalidade da BC do ICMS</Text>
              </div>
              <select
                name="mod_bc"
                className="form-control"
                id="mod_bc"
                onChange={onChange}
              >
                <option disabled selected>
                  Selecione
                </option>
                <option value={0} selected={data.mod_bc === 0}>
                  0=Margem Valor Agregado (%)
                </option>
                <option value={1} selected={data.mod_bc === 1}>
                  1=Pauta (Valor)
                </option>
                <option value={2} selected={data.mod_bc === 2}>
                  2=Preço Tabelado Máx. (valor)
                </option>
                <option value={3} selected={data.mod_bc === 3}>
                  3=Valor da operação
                </option>
              </select>
            </div>
          </div>
          <div className={`${data.bc_icms != null ? "col-md-4" : "d-none"}`}>
            <div className="form-group">
              <div className="form-label">
                <Text>Valor da BC do ICMS</Text>
              </div>
              <CurrencyInput
                value={data.bc_icms}
                prefix="R$ "
                decimalSeparator=","
                thousandSeparator="."
                onChange={(a, value, c) =>
                  onChange({ target: { name: "bc_icms", value } })
                }
                className="form-control"
              />
            </div>
          </div>
          <div className={`${data.v_icms != null ? "col-md-4" : "d-none"}`}>
            <div className="form-group">
              <div className="form-label">
                <Text>Valor do ICMS</Text>
              </div>
              <CurrencyInput
                value={data.v_icms}
                prefix="R$ "
                decimalSeparator=","
                thousandSeparator="."
                onChange={(a, value, c) =>
                  onChange({ target: { name: "v_icms", value } })
                }
                className="form-control"
              />
            </div>
          </div>
          {context.currentBranch.crt === 3 && (
            <div className="col-md-4">
              <div className="form-group">
                <div className="form-label">
                  <Text>Alíquota Interestadual</Text>
                </div>
                <CurrencyInput
                  value={data.p_icms_inter}
                  suffix=" %"
                  onChange={(a, value, c) =>
                    onChange({ target: { name: "p_icms_inter", value } })
                  }
                  className="form-control"
                />
              </div>
            </div>
          )}
          <div
            className={`${data.sample_icms && data.mod_bc_st != null ? "col-md-4" : "d-none"
              }`}
          >
            <div className="form-group">
              <div className="form-label">
                <Text>Modalidade da BC do ICMS ST</Text>
              </div>
              <select
                name="mod_bc_st"
                className="form-control"
                id="mod_bc_st"
                onChange={onChange}
              >
                <option disabled selected>
                  Selecione
                </option>
                <option value={0} selected={data.mod_bc_st === 0}>
                  0=Preço tabelado ou máximo sugerido
                </option>
                <option value={1} selected={data.mod_bc_st === 1}>
                  1=Lista Negativa (valor)
                </option>
                <option value={2} selected={data.mod_bc_st === 2}>
                  2=Lista Positiva (valor)
                </option>
                <option value={3} selected={data.mod_bc_st === 3}>
                  3=Lista Neutra (valor)
                </option>
                <option value={4} selected={data.mod_bc_st === 4}>
                  4=Margem Valor Agregado (%)
                </option>
                <option value={5} selected={data.mod_bc_st === 5}>
                  5=Pauta (valor)
                </option>
                <option value={6} selected={data.mod_bc_st === 6}>
                  6=Valor da Operação
                </option>
              </select>
            </div>
          </div>
          <div
            className={`${data.sample_icms && data.v_bc_st != null ? "col-md-4" : "d-none"
              }`}
          >
            <div className="form-group">
              <div className="form-label">
                <Text>Valor da BC do ICMS ST</Text>
              </div>
              <CurrencyInput
                value={data.v_bc_st}
                prefix="R$ "
                decimalSeparator=","
                thousandSeparator="."
                onChange={(a, value, c) =>
                  onChange({ target: { name: "v_bc_st", value } })
                }
                className="form-control"
              />
            </div>
          </div>
          <div
            className={`${data.sample_icms && data.v_icms_st != null ? "col-md-4" : "d-none"
              }`}
          >
            <div className="form-group">
              <div className="form-label">
                <Text>Valor do ICMS ST</Text>
              </div>
              <CurrencyInput
                value={data.v_icms_st}
                prefix="R$ "
                decimalSeparator=","
                thousandSeparator="."
                onChange={(a, value, c) =>
                  onChange({ target: { name: "v_icms_st", value } })
                }
                className="form-control"
              />
            </div>
          </div>
          <div
            className={`${data.sample_icms && data.p_mva_st != null ? "col-md-4" : "d-none"
              }`}
          >
            <div className="form-group">
              <div className="form-label">
                <Text>Margem Valor Adicionado ICMS ST (%)</Text>
              </div>
              <CurrencyInput
                value={data.p_mva_st}
                suffix=" %"
                onChange={(a, value, c) =>
                  onChange({ target: { name: "p_mva_st", value } })
                }
                className="form-control"
              />
            </div>
          </div>
          <div
            className={`${data.p_red_bc != null ? "col-md-4" : "d-none"
              }`}
          >
            <div className="form-group">
              <div className="form-label">
                <Text>% de Redução da BC</Text>
              </div>
              <CurrencyInput
                value={data.p_red_bc}
                suffix=" %"
                onChange={(a, value, c) =>
                  onChange({ target: { name: "p_red_bc", value } })
                }
                className="form-control"
              />
            </div>
          </div>
          <div
            className={`${data.sample_icms && data.p_red_bc_st != null
              ? "col-md-4"
              : "d-none"
              }`}
          >
            <div className="form-group">
              <div className="form-label">
                <Text>% de Redução da BC do ICMS ST</Text>
              </div>
              <CurrencyInput
                value={data.p_red_bc_st}
                suffix=" %"
                onChange={(a, value, c) =>
                  onChange({ target: { name: "p_red_bc_st", value } })
                }
                className="form-control"
              />
            </div>
          </div>
          <div
            className={`${data.sample_icms && data.p_icms_st != null ? "col-md-4" : "d-none"
              }`}
          >
            <div className="form-group">
              <div className="form-label">
                <Text>Alíquota do ICMS ST</Text>
              </div>
              <CurrencyInput
                value={data.p_icms_st}
                suffix=" %"
                onChange={(a, value, c) =>
                  onChange({ target: { name: "p_icms_st", value } })
                }
                className="form-control"
              />
            </div>
          </div>

          <div className={`${data.sample_icms ? "col-md-4" : "d-none"
            }`}>

            <div className="form-group">
              <div className="form-label">
                <Text>BC do FCP</Text>
              </div>
              <CurrencyInput
                value={data.bc_fcp}
                prefix="R$ "
                decimalSeparator=","
                thousandSeparator="."
                onChange={(a, value, c) =>
                  onChange({ target: { name: "bc_fcp", value } })
                }
                className="form-control"
              />
            </div>

          </div>


          <div className={`${data.sample_icms ? "col-md-4" : "d-none"
            }`}>

            <div className="form-group">
              <div className="form-label">
                <Text>Alíquota do FCP</Text>
              </div>
              <CurrencyInput
                value={data.p_fcp}
                suffix=" %"
                onChange={(a, value, c) =>
                  onChange({ target: { name: "p_fcp", value } })
                }
                className="form-control"
              />
            </div>

          </div>



          <div className={`${data.sample_icms ? "col-md-4" : "d-none"}`}>

            <div className="form-group">
              <div className="form-label">
                <Text>Valor do FCP</Text>
              </div>
              <CurrencyInput
                value={data.v_fcp}
                prefix="R$ "
                decimalSeparator=","
                thousandSeparator="."
                onChange={(a, value, c) =>
                  onChange({ target: { name: "v_fcp", value } })
                }
                className="form-control"
              />
            </div>

          </div>

          <div
            className={`${data.sample_icms && data.p_cred_sn != null ? "col-md-4" : "d-none"
              }`}
          >
            <div className="form-group">
              <div className="form-label">
                <Text>Alíquota de Crédito</Text>
              </div>
              <CurrencyInput
                value={data.p_cred_sn}
                suffix=" %"
                onChange={(a, value, c) =>
                  onChange({ target: { name: "p_cred_sn", value } })
                }
                className="form-control"
              />
            </div>
          </div>
          <div
            className={`${data.sample_icms && data.v_cred_icms_sn != null
              ? "col-md-4"
              : "d-none"
              }`}
          >
            <div className="form-group">
              <div className="form-label">
                <Text>Valor crédito do ICMS</Text>
              </div>
              <CurrencyInput
                value={data.v_cred_icms_sn}
                prefix="R$ "
                decimalSeparator=","
                thousandSeparator="."
                onChange={(a, value, c) =>
                  onChange({ target: { name: "v_cred_icms_sn", value } })
                }
                className="form-control"
              />
            </div>
          </div>
          <div
            className={`${data.sample_icms && data.v_bc_st_ret != null
              ? "col-md-4"
              : "d-none"
              }`}
          >
            <div className="form-group">
              <div className="form-label">
                <Text>Valor da BC do ICMS ST retido</Text>
              </div>
              <CurrencyInput
                value={data.v_bc_st_ret}
                prefix="R$ "
                decimalSeparator=","
                thousandSeparator="."
                onChange={(a, value, c) =>
                  onChange({ target: { name: "v_bc_st_ret", value } })
                }
                className="form-control"
              />
            </div>
          </div>
          <div
            className={`${data.v_icms_st_ret != null && data.sample_icms
              ? "col-md-4"
              : "d-none"
              }`}
          >
            <div className="form-group">
              <div className="form-label">
                <Text>Valor do ICMS ST retido</Text>
              </div>
              <CurrencyInput
                value={data.v_icms_st_ret}
                prefix="R$ "
                decimalSeparator=","
                thousandSeparator="."
                onChange={(a, value, c) =>
                  onChange({ target: { name: "v_icms_st_ret", value } })
                }
                className="form-control"
              />
            </div>
          </div>
        </div>
        {/* ─── Desoneração do ICMS ──────────────────────────────────────────────── */}
        <div className="row">
          <div className={`${data.v_icms_deson != null ? "col-md-6" : "d-none"}`}>
            <div className="form-group">
              <div className="form-label">
                <Text>Valor do ICMS Desonerado (vICMSDeson)</Text>
              </div>
              <CurrencyInput
                name="v_icms_deson"
                value={data.v_icms_deson}
                prefix="R$ "
                decimalSeparator=","
                thousandSeparator="."
                onChange={(a, value, c) =>
                  onChange({ target: { name: "v_icms_deson", value } })
                }
                className="form-control"
              />
            </div>
          </div>
          <div className={`${data.mot_des_icms != null ? "col-md-6" : "d-none"}`}>
            <div className="form-group">
              <div className="form-label">
                <Text>Motivo da Desoneração do ICMS (motDesICMS)</Text>
              </div>
              <select
                name="mot_des_icms"
                className="form-control"
                onChange={onChange}
                value={data.mot_des_icms || ""}
              >
                <option value="">Selecione o motivo</option>
                <option value="1">1 - Táxi</option>
                <option value="3">3 - Produtor Agropecuário</option>
                <option value="4">4 - Frotista/Locadora</option>
                <option value="5">5 - Diplomático/Consular</option>
                <option value="6">6 - Utilitários e Motocicletas da Amazônia Ocidental e Áreas de Livre Comércio (ALC)</option>
                <option value="7">7 - SUFRAMA</option>
                <option value="8">8 - Venda a órgão Público</option>
                <option value="9">9 - Outros</option>
                <option value="10">10 - Deficiente Condutor (Convênio ICMS 38/12)</option>
                <option value="11">11 - Deficiente não Condutor (Convênio ICMS 38/12)</option>
                <option value="12">12 - Órgão de Fomento e Desenvolvimento Agropecuário</option>
                <option value="16">16 - Olimpíadas Rio 2016</option>
              </select>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 d-flex justify-content-end py-4">
            <Button onClick={save}>Salvar ICMS</Button>
          </div>
        </div>
      </div>
    </IModal>
  );
}
function AdjstIPI(props) {
  const [data, setData] = React.useState({});
  function onChange(e) {
    const { name: key, value } = e.target;
    setData({
      ...data,
      [key]: value,
    });
    setTimeout(() => {
      if (["p_ipi", "bc_ipi"].includes(key)) {
        let percent = 0;
        let baseValue = 0;

        if (key === "p_ipi") {
          percent = value;
          baseValue = data.bc_ipi || 0;
        } else if (key === "bc_ipi") {
          baseValue = value;
          percent = data.p_ipi || 0;
        }
        const v_ipi = decimalFormat((percent / 100) * baseValue, 4);
        setData({
          ...data,
          [key]: value,
          v_ipi,
        });
      }
    }, 150);
  }
  function save() {
    props.onHide();
    props.onSave(data);
  }
  function open() {
    if (props.show === true) {
      setTimeout(() => {
        setData({
          ...props.data.ipi,
          item_sale_price: props.data.item_sale_price,
          quantity: props.data.quantity,
        });
      }, 250);
    } else {
      setData({});
    }
  }
  React.useEffect(open, [props.show]);
  return (
    <IModal show={props.show} title="IPI" onHide={props.onHide}>
      <div className="container">
        <div className="row">
          <div className="col-6 col-xs-12">
            <div className="form-group">
              <div className="form-label">
                <Text>CST IPI</Text>
              </div>
              <select name="cst" onChange={onChange} className="form-control">
                <option value="" selected disabled>
                  Selecione o CST
                </option>
                {CSTIPI.map((cst, idx) => {
                  return (
                    <option
                      selected={data.cst === cst.code}
                      value={cst.code}
                      key={`nfe-edit-template-ipi${idx}`}
                    >
                      {cst.code} - {cst.description}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className="col-6 col-xs-12">
            <div className="form-group">
              <div className="form-label">
                <Text>Cód. Enquadramento IPI</Text>
              </div>
              <input
                onChange={onChange}
                name="c_enq"
                value={data.c_enq}
                type="text"
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6 col-xs-12">
            <div className="form-group">
              <div className="form-label">
                <Text>Alíquota IPI</Text>
              </div>
              <CurrencyInput
                value={data.p_ipi}
                suffix=" %"
                onChange={(a, value, c) =>
                  onChange({ target: { name: "p_ipi", value } })
                }
                className="form-control"
              />
            </div>
          </div>
          <div className="col-6 col-xs-12">
            <div className="form-group">
              <div className="form-label">
                <Text>Base Cálculo IPI</Text>
              </div>
              <CurrencyInput
                value={data.bc_ipi}
                prefix="R$ "
                decimalSeparator=","
                thousandSeparator="."
                onChange={(a, value, c) =>
                  onChange({ target: { name: "bc_ipi", value } })
                }
                className="form-control"
              />
            </div>
          </div>
          <div className="col-6 col-xs-12">
            <div className="form-group">
              <div className="form-label">
                <Text>Valor do IPI</Text>
              </div>
              <CurrencyInput
                value={data.v_ipi}
                prefix="R$ "
                decimalSeparator=","
                thousandSeparator="."
                onChange={(a, value, c) =>
                  onChange({ target: { name: "v_ipi", value } })
                }
                className="form-control"
              />
            </div>
          </div>
          <div className="col-12 d-flex justify-content-end py-4">
            <Button onClick={save}>Salvar IPI</Button>
          </div>
        </div>
      </div>
    </IModal>
  );
}
function AdjustPIS(props) {
  const [data, setData] = React.useState({});

  function onChange(e) {
    const { name: key, value } = e.target;
    setData({
      ...data,
      [key]: value,
    });
    setTimeout(() => {
      if (["p_pis", "bc_pis"].includes(key)) {
        let percent = 0;
        let baseValue = 0;

        if (key === "p_pis") {
          percent = value;
          baseValue = data.bc_pis || 0;
        } else if (key === "bc_pis") {
          baseValue = value;
          percent = data.p_pis || 0;
        }
        const v_pis = decimalFormat((percent / 100) * baseValue, 4);

        setData({
          ...data,
          [key]: value,
          v_pis,
        });
      }
    }, 150);
  }

  function open() {
    if (props.show === true) {
      setTimeout(() => {
        const { bc_pis, ...rest } = props.data.pis || {}
        setData(rest)
      }, 250);
    } else {
      setData({});
    }
  }

  function save() {
    props.onSave(data);
    props.onHide();
  }

  React.useEffect(open, [props.show]);
  return (
    <IModal title="PIS" show={props.show} onHide={props.onHide}>
      <div className="container">
        <div className="row">
          <div className="col-6 col-xs-12">
            <div className="form-group">
              <div className="form-label">
                <Text>CST PIS</Text>
              </div>
              <select name="cst" className="form-control" onChange={onChange}>
                <option value="" disabled>
                  Selecione o CST
                </option>
                {CSTPIS.map((cst, idx) => {
                  return (
                    <option
                      selected={data.cst === cst.value}
                      value={cst.value}
                      key={`nfe-edit-template-ipi${idx}`}
                    >
                      {cst.value} - {cst.label}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className="col-6 col-xs-12">
            <div className="form-group">
              <div className="form-label">
                <Text>Alíquota PIS</Text>
              </div>
              <CurrencyInput
                value={data.p_pis}
                suffix=" %"
                onChange={(a, value, c) =>
                  onChange({ target: { name: "p_pis", value } })
                }
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6 col-xs-12">
            <div className="form-group">
              <div className="form-label">
                <Text>Base Cálculo PIS</Text>
              </div>
              <CurrencyInput
                value={data.bc_pis}
                prefix="R$ "
                decimalSeparator=","
                thousandSeparator="."
                onChange={(a, value, c) =>
                  onChange({ target: { name: "bc_pis", value } })
                }
                className="form-control"
              />
            </div>
          </div>
          <div className="col-6 col-xs-12">
            <div className="form-group">
              <div className="form-label">
                <Text>Valor do PIS</Text>
              </div>
              <CurrencyInput
                value={data.v_pis}
                prefix="R$ "
                decimalSeparator=","
                thousandSeparator="."
                onChange={(a, value, c) =>
                  onChange({ target: { name: "v_pis", value } })
                }
                className="form-control"
              />
            </div>
          </div>
          <div className="col-12 d-flex justify-content-end py-4">
            <Button onClick={save}>Salvar PIS</Button>
          </div>
        </div>
      </div>
    </IModal>
  );
}
function AdjustCOFINS(props) {
  const [data, setData] = React.useState({});

  function onChange(e) {
    const { name: key, value } = e.target;
    setTimeout(() => {
      if (["p_cofins", "bc_cofins"].includes(key)) {
        let percent = 0;
        let baseValue = 0;

        if (key === "p_cofins") {
          percent = value;
          baseValue = data.bc_cofins || 0;
        } else if (key === "bc_cofins") {
          baseValue = value;
          percent = data.p_cofins || 0;
        }

        const v_cofins = decimalFormat((percent / 100) * baseValue, 4);

        setData({
          ...data,
          [key]: value,
          v_cofins,
        });
      } else {
        setData({
          ...data,
          [key]: value,
        });
      }
    }, 150);
  }

  function open() {
    if (props.show === true) {
      setTimeout(() => {
        const { bc_cofins, ...rest } = props.data.cofins || {}
        setData(rest)
      }, 250);
    } else {
      setData({});
    }
  }

  function save() {
    props.onSave(data);
    props.onHide();
  }

  React.useEffect(open, [props.show]);
  return (
    <IModal title="COFINS" show={props.show} onHide={props.onHide}>
      <div className="container">
        <div className="row">
          <div className="col-6 col-xs-12">
            <div className="form-group">
              <div className="form-label">
                <Text>CST COFINS</Text>
              </div>
              <select onChange={onChange} name="cst" className="form-control">
                <option value="" selected disabled>
                  Selecione o CST
                </option>
                {CSTCOFINS.map((cst, idx) => {
                  return (
                    <option
                      selected={data.cst === cst.value}
                      value={cst.value}
                      key={`nfe-edit-template-ipi${idx}`}
                    >
                      {cst.value} - {cst.label}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className="col-6 col-xs-12">
            <div className="form-group">
              <div className="form-label">
                <Text>Alíquota COFINS</Text>
              </div>
              <CurrencyInput
                value={data.p_cofins}
                suffix=" %"
                onChange={(a, value, c) =>
                  onChange({ target: { name: "p_cofins", value } })
                }
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6 col-xs-12">
            <div className="form-group">
              <div className="form-label">
                <Text>Base Cálculo COFINS</Text>
              </div>
              <CurrencyInput
                value={data.bc_cofins}
                prefix="R$ "
                decimalSeparator=","
                thousandSeparator="."
                onChange={(a, value, c) =>
                  onChange({ target: { name: "bc_cofins", value } })
                }
                className="form-control"
              />
            </div>
          </div>
          <div className="col-6 col-xs-12">
            <div className="form-group">
              <div className="form-label">
                <Text>Valor do COFINS</Text>
              </div>
              <CurrencyInput
                value={data.v_cofins}
                prefix="R$ "
                decimalSeparator=","
                thousandSeparator="."
                onChange={(a, value, c) =>
                  onChange({ target: { name: "v_cofins", value } })
                }
                className="form-control"
              />
            </div>
          </div>
          <div className="col-12 d-flex justify-content-end py-4">
            <Button onClick={save}>Salvar COFINS</Button>
          </div>
        </div>
      </div>
    </IModal>
  );
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/Items/list.jsx